const variant = Object.freeze({
  BLUE: 'blue',
  WHITE: 'white'
})

export { variant }
